import CreatedAccount from './CreatedAccount'

export default CreatedAccount
